<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    class=""
  >
    <circle cx="12" cy="12" r="10" stroke="#a6abb6" fill="#fff" />
    <line x1="8" y1="8" x2="16" y2="16" stroke="#a6abb6" stroke-width="2" />
    <line x1="16" y1="8" x2="8" y2="16" stroke="#a6abb6" stroke-width="2" />
  </svg>
</template>
